import styled from 'styled-components';
import { Input } from 'src/UIComponents';

import { getFontColor } from 'src/UIComponents/utils/colors';

export const TagTitle = styled.h4`
  display: inline-block;
  background-color: ${({ color }) => color};
  color: ${({ color }) => getFontColor(color)};
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.md};
  border-radius: 6px;
  margin-bottom: 0;
`;

export const TagColor = styled.span`
  color: ${({ color }) => color};
  font-weight: bold;
  display: inline-block;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const Colorpicker = styled(Input).attrs({
  type: 'color',
})`
  height: 3em;
  border: 0;
  background: 0;
  padding: 0;
`;
